import { Routes, Route } from 'react-router-dom';
import Topbar from './components/Topbar.jsx';
import Footer from './components/Footer.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import HomePage from './pages/HomePage.jsx';
import FirmPage from './pages/FirmPage.jsx';
import PracticePage from './pages/PracticePage.jsx';
import FounderPage from './pages/FounderPage.jsx';
import InsightsPage from './pages/InsightsPage.jsx';
import InsightDetailPage from './pages/InsightDetailPage.jsx';
import MediaArticlePage from './pages/MediaArticlePage.jsx';
// Privacy (/privacy) and Notices (/notices) are hidden pending legal sign-off.
// To restore: re-add the imports and routes below, and the footer links in Footer.jsx.
// import PrivacyPage from './pages/PrivacyPage.jsx';
// import NoticesPage from './pages/NoticesPage.jsx';
import AdminLogin from './pages/admin/Login.jsx';
import AdminLayout from './pages/admin/Layout.jsx';
import InsightList from './pages/admin/InsightList.jsx';
import InsightEditor from './pages/admin/InsightEditor.jsx';
import MediaList from './pages/admin/MediaList.jsx';
import MediaEditor from './pages/admin/MediaEditor.jsx';

export default function App() {
  return (
    <Routes>
      {/* Admin - no chrome */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<InsightList />} />
        <Route path="insights/new" element={<InsightEditor />} />
        <Route path="insights/:id/edit" element={<InsightEditor />} />
        <Route path="media" element={<MediaList />} />
        <Route path="media/new" element={<MediaEditor />} />
        <Route path="media/:id/edit" element={<MediaEditor />} />
      </Route>

      {/* Public pages */}
      <Route path="*" element={
        <>
          <ScrollToTop />
          <Topbar />
          <Routes>
            <Route path="/"         element={<HomePage />} />
            <Route path="/firm"     element={<FirmPage />} />
            <Route path="/practice" element={<PracticePage />} />
            <Route path="/founder"  element={<FounderPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:id" element={<InsightDetailPage />} />
            <Route path="/media/:id" element={<MediaArticlePage />} />
            {/* <Route path="/privacy"  element={<PrivacyPage />} /> */}
            {/* <Route path="/notices"  element={<NoticesPage />} /> */}
            <Route path="*"         element={<HomePage />} />
          </Routes>
          <Footer />
        </>
      } />
    </Routes>
  );
}
